/**
 * A module of methods that you want to include in all stores.
 * This module is consumed by `createStore`.
 */
module.exports = {
};



//////////////////
// WEBPACK FOOTER
// ./ext_libraries/reflux/src/StoreMethods.js
// module id = 217
// module chunks = 0